"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const checkBannerToggle = toggles => {
  var _toggles$find;
  const isBannerToggleEnabled = ((_toggles$find = toggles.find(toggle => toggle.name === 'IsNotificationBannerEnabled')) === null || _toggles$find === void 0 ? void 0 : _toggles$find.isOn) || false;
  return isBannerToggleEnabled;
};
var _default = exports.default = checkBannerToggle;